<template>
  <div class="w-100">
    <div v-if="title" class="atom-multi-select--title">
      {{ title
      }}<label v-if="isAsterisk" class="atom-multi-select--asterisk">*</label>
    </div>
    <div
      :class="[
        { 'multi-select--edit-tag': isSmall },
        isDisable
          ? 'atom-multi-select-disable__container'
          : 'atom-multi-select__container',
      ]"
    >
      <b-form-group :state="state" class="mb-0">
        <v-select
          :multiple="true"
          :taggable="isPushTaggable"
          v-model="selectValue"
          :label="label"
          :options="option"
          :placeholder="placeholder"
          :disabled="isDisable"
          :append-to-body="isAppendToBody"
          :calculate-position="isEnableProper ? withPopper : () => undefined"
        >
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes">
              <feather-icon icon="ChevronDownIcon"
            /></span>
          </template>
        </v-select>
      </b-form-group>
      <div v-if="isError" class="error-message">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem, BDropdownDivider } from "bootstrap-vue"
import vSelect from "vue-select"
import { BFormGroup } from "bootstrap-vue"
import { createPopper } from "@popperjs/core"
export default {
  name: "AtomMultiSelect",
  components: {
    vSelect,
    BFormGroup,
    BDropdown,
    BDropdownDivider,
    BDropdownItem,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    label: {
      // name of the key field that will show as an option in dropdowm.
      type: String,
      required: false,
      default: "label",
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    isError: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorMessage: {
      type: String,
      required: false,
      default: "",
    },
    isPushTaggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSmall: {
      type: Boolean,
      required: false,
      default: false,
    },
    option: {
      type: Array,
      required: true,
    },
    isEnableProper: {
      type: Boolean,
      required: false,
      default: true,
    },
    isAppendToBody: {
      type: Boolean,
      required: false,
      default: true,
    },
    value: {
      type: [String, Number, Array, Object, null],
      required: false,
      default: null,
    },
    isAsterisk: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      placement: "top",
    }
  },
  computed: {
    selectValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    state() {
      return this.isError && !this.isDisable ? !this.isError : true
    },
  },
  methods: {
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1],
            },
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              )
            },
          },
        ],
      })
      return () => popper.destroy()
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.atom-multi-select__container::v-deep .vs__search::placeholder {
  padding-left: 0.35rem;
  color: #b9b9c3;
}

.atom-multi-select__container .vs__search {
  &:focus {
    margin-left: 0.4rem;
  }
}

.atom-multi-select__container.multi-select--edit-tag .vs__search {
  margin: 0;
}

.atom-multi-select__container .vs__selected {
  color: #7367f0 !important;
  background-color: #eeedfd !important;
  font-weight: 600;
  border-radius: 4px;
}
.atom-multi-select-disable__container .vs__selected {
  color: #83878c !important;
  background-color: #f8f8f8 !important;
  font-weight: 600;
  border-radius: 4px;
}

.atom-multi-select-disable__container .vs__deselect {
  display: none;
}

.vs__deselect {
  fill: #7367f0 !important;
  margin-bottom: 2px;
  margin-left: 8px;
}

.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
}

.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 4px !important;
  border-color: #7367f0 !important;
}

.atom-multi-select--title {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 1.5;
}
.atom-multi-select--asterisk {
  color: #ea5455;
  font-size: 12px;
  margin-bottom: 0;
}

.error-message {
  line-height: 1.5;
  font-size: 12px;
  color: #ea5455;
}
</style>
